// extracted by mini-css-extract-plugin
module.exports = {"nextImageWrapper":"Image_nextImageWrapper__f3o5u","contain":"Image_contain__904or","loadingState":"Image_loadingState__uTL30"};